// @flow
import * as React from 'react';

import { useRef, useEffect } from 'react';

import clsx from 'clsx';

import { Svg } from '@gandi/ui';

import { HeaderLogo, NavigationMenu } from '@gandi/ui/layout';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectWebURL } from 'src/modules/config';

import { useNavigationMenus, useIsMobile } from '../../hooks';

import UserWidgetMobile from '../UserWidget/UserWidgetMobile';

import { HeaderMenuContext } from './HeaderMenuContext';

import styles from './LandingPagesControls.scss';

export function LandingPagesControls(): React.MixedElement {
  const webURL = useAppSelector(selectWebURL);

  // Burger menu state
  const { mainMenuOpen } = React.useContext(HeaderMenuContext);

  // Main menu ctn
  const overlayRef = useRef<?HTMLDivElement>(null);

  // Menu items
  const menuItems = useNavigationMenus();

  // Prevent page scroll while the overlay is open
  const isMobile = useIsMobile();
  useEffect(() => {
    if (!isMobile || typeof document === 'undefined' || !document.body) {
      return () => {};
    }

    const prev = document.body.style.overflow;
    document.body.style.overflow = mainMenuOpen ? 'hidden' : prev || '';

    return () => {
      if (document.body) document.body.style.overflow = prev || '';
    };
  }, [mainMenuOpen, isMobile]);

  // Focus on the overlay (main menu ctn) when menu is open
  useEffect(() => {
    if (mainMenuOpen && overlayRef.current) {
      overlayRef.current.focus();
    }
  }, [mainMenuOpen]);

  return (
    <>
      <HeaderLogo
        href={webURL}
        childrenDesktop={
          <Svg name="gandi" style={{ height: 28, width: 'auto' }} />
        }
        childrenMobile={
          <Svg name="gandiIcon" style={{ height: 28, width: 'auto' }} />
        }
      />

      {/* Navigation menu */}
      <div
        id="mainmenu"
        ref={overlayRef}
        className={clsx(styles.overlay, {
          [styles.overlayOpen]: mainMenuOpen,
        })}
        tabIndex={-1}
      >
        <div className={styles.overlayInner}>
          <NavigationMenu menus={menuItems} />
          {mainMenuOpen && <UserWidgetMobile />}
        </div>
      </div>
    </>
  );
}
